<template>
  <div class="newsDetail">
    <Card>
      <div style="width: 80%;margin: 20px auto">
        <h2 style="text-align: center;font-size: 26px;margin-bottom: 20px">{{ formValidate.title }}</h2>
<!--        <p style="text-align: center;margin-top: 10px">作者：{{ formValidate.createUserName }} &nbsp;&nbsp;&nbsp;&nbsp;-->
<!--          发布时间：{{ $moment(formValidate.createTime).format('YYYY-MM-DD HH:mm') }}</p>-->
<!--        <div style="margin-top: 10px">-->
<!--          <p class="description">{{ formValidate.description }}</p>-->
<!--          <p class="position">施工位置：{{ formValidate.position }}</p>-->
<!--          <p class="unit">施工单位：{{ formValidate.unit }}</p>-->
<!--          <p class="lockdownSituation">封控情况：{{ formValidate.lockdownSituation }}</p>-->
<!--          <p class="superviseSituation">监管情况：{{ formValidate.superviseSituation }}</p>-->
        <Form :label-width="100" label-postion="left">
          <FormItem label="事件标题:">
            <Input v-model="formValidate.title" clearable disabled></Input>
          </FormItem>
          <FormItem label="事件类型:">
            <Input v-model="formValidate.createUserName" disabled></Input>
          </FormItem>
          <FormItem label="发布时间:">
            <DatePicker v-model="formValidate.createTime" disabled></DatePicker>
          </FormItem>
          <FormItem label="事件描述:">
            <Input type="textarea" v-model="formValidate.description" disabled></Input>
          </FormItem>
          <FormItem label="施工位置:">
            <Input type="textarea" v-model="formValidate.position" disabled></Input>
          </FormItem>
          <FormItem label="施工单位:">
            <Input v-model="formValidate.unit" disabled></Input>
          </FormItem>
          <FormItem label="封控情况:">
            <Input type="textarea" v-model="formValidate.lockdownSituation" disabled></Input>
          </FormItem>
<!--          <FormItem label="监管情况">-->
<!--            <Input v-model="formValidate.superviseSituation" clearable></Input>-->
<!--          </FormItem>-->
        </Form>
        </div>
<!--        <div v-html="formValidate.content"></div>-->
<!--      </div>-->
      <div id="map"></div>
    </Card>
  </div>
</template>

<script>
export default {
  name: "newsDetail",
  data() {
    return {
      map: null,
      formValidate: {}
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    // 获取详情
    getDetail() {
      let id = this.$route.query.id
      this.$http.get(`/api/newsReleases/${id}`).then(res => {
        if (res.status === 200) {
          this.formValidate = res.data
          this.initMap()
        }
      })
    },
    initMap() {
      this.map = new BMapGL.Map("map");          // 创建地图实例
      let positionList = this.formValidate.positionList
      let longitude = positionList[positionList.length / 2].longitude
      let latitude = positionList[positionList.length / 2].latitude
      let point = new BMapGL.Point(longitude, latitude);  // 创建点坐标
      this.map.centerAndZoom(point, 15);
      this.map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
      this.setMarker()
      this.setPolyline()
    },
    setMarker() {
      let positionList = this.formValidate.positionList
      positionList.map(item => {
        return {
          longitude: parseFloat(item.longitude),
          latitude: parseFloat(item.longitude)
        }
      })

      for (let i in positionList) {
        let point = new BMapGL.Point(positionList[i].longitude, positionList[i].latitude);
        let marker = new BMapGL.Marker(point);        // 创建标注
        this.map.addOverlay(marker);                     // 将标注添加到地图中
      }
    },
    setPolyline() {
      let positionList = this.formValidate.positionList
      let positionLisPoint= positionList.map(item => {
        return new BMapGL.Point(parseFloat(item.longitude), parseFloat(item.latitude))
      })
      console.log(positionLisPoint)
      let polyline = new BMapGL.Polyline(positionLisPoint, {strokeColor: "red", strokeWeight: 10, strokeOpacity: 0.5});   //创建折线
      console.log(polyline)
      this.map.addOverlay(polyline);   //增加折线
    },
  }
}
</script>

<style scoped lang="less">
#map {
  width: 80%;
  height: 400px;
  margin: 20px auto 0;
}

.description {
  text-indent: 2em;
  line-height: 28px;
  text-align: justify;
  font-size: 16px;
}

.position {
  text-align: left;
  line-height: 28px;
}

.unit {
  text-align: left;
  line-height: 28px;
}

.lockdownSituation {
  text-align: left;
  line-height: 28px;
}

.superviseSituation {
  text-align: left;
  line-height: 28px;
}
</style>
